
import React, { PureComponent } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { enLang } from 'interfaces/IProductData';
import { SvgIcon } from 'components/SvgIcon';

export interface IProps {
  option: {
    lang: enLang;
    text: string;
  };
  selected: boolean;
  onSelect: (currency: enLang) => void;
}

export default class LangItem extends PureComponent<IProps> {

  onSelect = () => {
    this.props.onSelect(this.props.option.lang);
  }

  render() {

    const { option } = this.props;

    return (
      <MenuItem
        selected={this.props.selected}
        onClick={this.onSelect}
      >
        <div className='country-menu-item'>
          <SvgIcon name={`flag_${option.lang}`} />
          {option.text}
        </div>
      </MenuItem>);
  }

}


// WEBPACK FOOTER //
// ./src/components/Cart/ConfigCountry/LangItem.tsx